export const tKey = 'core.special_offer';